<template>
  <div>
    <van-popup
      v-model="forceRead"
      round
      class="inPop forceRead"
    >
      <component
        :is="forceReadComponent"
        :hidePopup="hideForcePopup"
      ></component>
      <div
        @click="forceReadSure"
        class="forceReadBtn"
        :class="forceReadText !== forceReadDoneText ? 'disable' : ''"
      >{{ forceReadText }}</div>
    </van-popup>
    <van-popup v-model="show" round class="inPop">
      <component
        v-if="currentComponent"
        :is="currentComponent"
        :hidePopup="hidePopup"
        :contract="currentContract"
      ></component>
    </van-popup>
    <div
      v-for="group in contractGroups"
      :key="group.value"
      class="agreement"
    >
      <img
        class="selectImg"
        :src="checkedMap[group.value] ? Select : NoSelect"
        alt=""
        @click="toggleGroup(group)"
      >
      <span class="agreementText" @click="toggleGroup(group)">{{ text }}</span>
      <template v-for="(contract, index) in group.contracts">
        <span
          :key="contract.value"
          class="agreement_content"
          @click="showPopup(contract)"
        >《{{ contract.text }}》</span>
        <span
          v-if="index < group.contracts.length - 1"
          :key="`${contract.value}_and`"
        >&amp;</span>
      </template>
    </div>
  </div>
</template>

<script>
import EnterpriseAuthorizationAgreement from '@/components/FeildTwo/components/EnterpriseAuthorizationAgreement.vue';
import XydPdfAgreement from '@/components/FeildTwo/components/XydPdfAgreement.vue';
import NoSelect from '@/assets/images/weixuanzhong.png';
import Select from '@/assets/images/xuanzhong.png';

const CONTRACT_COMPONENT_MAP = {
  bw_sq: 'EnterpriseAuthorizationAgreement',
  xyd_zc: 'XydPdfAgreement',
  xyd_xxbh: 'XydPdfAgreement',
  xyd_clxq: 'XydPdfAgreement',
  xyd_gxsq: 'XydPdfAgreement',
  xyd_fwxy: 'XydPdfAgreement',
};

export default {
  name: 'XydContractGroup',
  components: {
    EnterpriseAuthorizationAgreement,
    XydPdfAgreement,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    text: {
      type: String,
      default: '本人已阅读并完全同意',
    },
    value: Boolean,
    defaultCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const checkedMap = {};
    this.list.forEach((group) => {
      checkedMap[group.value] = this.defaultCheck;
    });
    return {
      NoSelect,
      Select,
      checkedMap,
      forceRead: false,
      forceReadGroup: null,
      forceReadComponent: '',
      forceReadText: '我已阅读',
      forceReadDoneText: '我已阅读',
      forceReadTimer: null,
      count: 0,
      show: false,
      currentContract: null,
    };
  },
  computed: {
    contractGroups() {
      return this.list;
    },
    allChecked() {
      return this.contractGroups.length > 0
        && this.contractGroups.every((group) => this.checkedMap[group.value]);
    },
    currentComponent() {
      if (!this.currentContract) {
        return '';
      }
      return CONTRACT_COMPONENT_MAP[`${this.currentContract.value}`.toLowerCase()] || '';
    },
  },
  mounted() {
    this.$emit('input', this.allChecked);
  },
  methods: {
    toggleGroup(group) {
      if (this.needForceRead(group)) {
        this.showForceRead(group);
        return;
      }
      this.$set(this.checkedMap, group.value, !this.checkedMap[group.value]);
      this.$emit('input', this.allChecked);
    },
    needForceRead(group) {
      return !this.checkedMap[group.value]
        && group.contracts
        && group.contracts.some((contract) => `${contract.value}`.toLowerCase() === 'bw_sq');
    },
    showForceRead(group) {
      const contract = group.contracts.find((item) => `${item.value}`.toLowerCase() === 'bw_sq');
      const component = contract ? CONTRACT_COMPONENT_MAP[`${contract.value}`.toLowerCase()] : '';
      if (!component) {
        this.$set(this.checkedMap, group.value, true);
        this.$emit('input', this.allChecked);
        return;
      }
      this.forceReadGroup = group;
      this.forceReadComponent = component;
      this.count = 3;
      this.forceRead = true;
      this.forceReadText = `${this.forceReadDoneText}(${this.count--})`;
      clearInterval(this.forceReadTimer);
      this.forceReadTimer = setInterval(() => {
        if (this.count > 0) {
          this.forceReadText = `${this.forceReadDoneText}(${this.count--})`;
        } else {
          this.forceReadText = this.forceReadDoneText;
          clearInterval(this.forceReadTimer);
        }
      }, 1000);
    },
    forceReadSure() {
      if (this.forceReadText !== this.forceReadDoneText) {
        return;
      }
      if (this.forceReadGroup) {
        this.$set(this.checkedMap, this.forceReadGroup.value, true);
        this.$emit('input', this.allChecked);
      }
      this.forceRead = false;
      this.forceReadGroup = null;
      clearInterval(this.forceReadTimer);
    },
    showPopup(contract) {
      this.currentContract = contract;
      this.show = true;
    },
    hidePopup() {
      this.show = false;
    },
    hideForcePopup() {
      this.forceRead = false;
      this.forceReadGroup = null;
      clearInterval(this.forceReadTimer);
    },
  },
  beforeDestroy() {
    clearInterval(this.forceReadTimer);
  },
};
</script>

<style scoped>
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}
.forceRead {
  padding-bottom: 50px;
  overflow: hidden;
}
.forceReadBtn {
  background: #ff6538;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
}
.disable {
  background: #d7d7d7;
}
.agreement {
  box-sizing: border-box;
  margin: 0 15px;
  color: #9ea7b4;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  position: relative;
}
.agreement + .agreement {
  margin-top: 6px;
}
.agreement .agreement_content {
  color: #ff6538;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 5px;
  left: 0;
}
.agreementText {
  margin-left: 20px;
}
</style>
